<template lang="html">
  <div class="sticky-fab" :class="{ transitioning, 'disable-goo': isNotChrome }">
    <transition name="fadetwist" @after-enter="transitioning = false" @after-leave="transitioning = false">
      <button v-if="!expanded" :aria-label="base" class="base" :disabled="disabled" key="base" @click="expand">
        <Icon :icon="base" />
      </button>
    </transition>
    <button v-for="(action, index) in actions" :aria-label="action.icon" :class="{ expanded, 'no-shadow': !expanded }" :disabled="disabled" :key="index" :style="{ left: expanded ? `calc(${(index + 1) / (actions.length + 1) * 100}% - 28px)` : ''}" @click="callAction(action.action)">
      <Icon :icon="action.icon" />
    </button>
    <svg class="goo-filter" xmlns="http://www.w3.org/2000/svg" version="1.1">
      <defs>
        <filter id="goo">
          <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
          <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="goo" />
          <feBlend in="SourceGraphic" in2="goo" />
        </filter>
      </defs>
    </svg>
  </div>
</template>

<script>
import Icon from './Icon.vue';

export default {
  components: {
    Icon,
  },
  computed: {
    isNotChrome() {
      return !window.chrome;
    },
  },
  data() {
    return {
      expanded: false,
      transitioning: false,
    };
  },
  methods: {
    callAction(action) {
      this.collapse(null, true);
      action();
    },
    collapse(event, force) {
      if (force || !this.$el.contains(event.target)) {
        this.transitioning = true;
        this.expanded = false;
        window.removeEventListener('click', this.collapse);
        window.removeEventListener('touchend', this.collapse);
        this.$emit('collapsed');
      }
    },
    expand() {
      if (this.baseAction) this.baseAction();
      if (!this.expandable) return;
      this.expanded = true;
      this.transitioning = true;
      window.addEventListener('click', this.collapse);
      window.addEventListener('touchend', this.collapse);
    },
  },
  props: {
    actions: Array,
    base: String,
    baseAction: Function,
    disabled: Boolean,
    expandable: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '../styles/colors'
@require '../styles/shadows'

.sticky-fab
  position: relative
  pointer-events: none

  &.transitioning:not(.disable-goo)
    filter: url('#goo')

    button
      box-shadow: none

  &:not(.transitioning)
    button:not(.expanded):not(.base)
      visibility: hidden

    .base
      transition-delay: unset
      transition: transform 200ms ease, box-shadow 200ms ease, opacity 200ms ease

      &:active:not(:disabled)
        transform: scale(1.2)

  button
    background-color: $text
    border: none
    width: 56px
    height: @width
    border-radius: (@width / 2)px
    box-shadow: $interactable-shadow
    position: absolute
    left: calc(50% - 28px)
    transition: left 500ms cubic-bezier(0.680, -0.550, 0.265, 1.550), box-shadow 200ms ease, opacity 200ms ease
    transition-delay: 100ms
    pointer-events: all

    &.expanded
      transition-delay: unset

    &.no-shadow,
    &:active
      box-shadow: unset

    &:first-child
      position: relative
      z-index: 2

    &.fadetwist-enter-active,
    &.fadetwist-leave-active
      transition: opacity 200ms ease, transform 500ms cubic-bezier(0.680, -0.550, 0.265, 1.550)

      &.fadetwist-enter,
      &.fadetwist-leave-to
        transform: scale(0)

      &.fadetwist-leave-to
        transition-delay: 150ms

    &:disabled
      opacity: 0.5
      box-shadow: unset

  svg.goo-filter
    display: none
</style>
